"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8662],{

/***/ 38662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ characters_CharacterCardList; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/react-query-virtual-8f3bd3534b/0/cache/react-query-npm-3.39.3-72b2a93edf-d2de6a0992.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(54909);
// EXTERNAL MODULE: ./hooks/query/usePlayer.ts
var usePlayer = __webpack_require__(75046);
// EXTERNAL MODULE: ./hooks/query/useUserQuery.ts
var useUserQuery = __webpack_require__(75319);
// EXTERNAL MODULE: ./hooks/useBroadcastChannel.ts
var useBroadcastChannel = __webpack_require__(41785);
// EXTERNAL MODULE: ./hooks/useModal.ts
var useModal = __webpack_require__(48294);
// EXTERNAL MODULE: ./hooks/useScrollPosition.ts
var useScrollPosition = __webpack_require__(80786);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/form/index.js + 4 modules
var components_form = __webpack_require__(61527);
// EXTERNAL MODULE: ./components/common/Empty.tsx
var Empty = __webpack_require__(34270);
// EXTERNAL MODULE: ./components/common/Pagination.tsx
var Pagination = __webpack_require__(39753);
// EXTERNAL MODULE: ./components/modal/CharacterDeleteModal.tsx
var CharacterDeleteModal = __webpack_require__(60280);
// EXTERNAL MODULE: ./api/chatbot.ts
var chatbot = __webpack_require__(23082);
// EXTERNAL MODULE: ./constants/index.ts + 2 modules
var constants = __webpack_require__(45432);
// EXTERNAL MODULE: ./contexts/global.ts
var global = __webpack_require__(30259);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
// EXTERNAL MODULE: ./utils/query.ts
var query = __webpack_require__(96261);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
;// CONCATENATED MODULE: ./components/common/Card.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  min-height: 216px;\n  flex-direction: column;\n  border-radius: ",
        "px;\n  overflow: hidden;\n  background-color: ",
        ";\n  box-shadow: 3px -2px 20px 10px #0000000d;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var containerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject(), dist_esm/* Radius.small */.wU.small, theme.var.white);
};
var Card = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: containerCSS,
        children: children
    });
};
/* harmony default export */ var common_Card = (Card);

// EXTERNAL MODULE: ./components/common/SvgIcon.tsx
var SvgIcon = __webpack_require__(34368);
;// CONCATENATED MODULE: ./public/icons/ic_plus_bold.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIcPlusBold = function SvgIcPlusBold(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M14.531 3.75a1.406 1.406 0 0 1 1.406 1.406v7.969h7.97a1.406 1.406 0 0 1 0 2.813h-7.97v7.968a1.406 1.406 0 0 1-2.812 0v-7.968H5.156a1.406 1.406 0 0 1 0-2.813h7.969V5.156a1.406 1.406 0 0 1 1.406-1.406"
  })));
};
/* harmony default export */ var ic_plus_bold = (SvgIcPlusBold);
;// CONCATENATED MODULE: ./components/characters/CharacterAddCard.tsx
function CharacterAddCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CharacterAddCard_templateObject() {
    var data = CharacterAddCard_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  width: 166px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: ",
        "px;\n\n  ",
        ";\n  font-size: 12px;\n  line-height: 16.2px;\n  text-align: center;\n"
    ]);
    CharacterAddCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = CharacterAddCard_taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    height: 60px;\n    background: ",
        ";\n    border-radius: ",
        "px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var CharacterAddCard_containerCSS = (0,emotion_react_browser_esm.css)(CharacterAddCard_templateObject(), dist_esm/* Spacing.large */.Ki.large, dist_esm/* Typography.h6 */.ZT.h6);
var plusCSS = function(isCheming) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject1(), isCheming ? "".concat(theme.colors.main500) : "linear-gradient(90deg, #04c8d0 0%, #1590d5 95.45%)", dist_esm/* Radius.round */.wU.round);
    };
};
var CharacterAddCard = function(param) {
    var handleOnClick = param.handleOnClick, isCheming = param.isCheming;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(common_Card, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            css: CharacterAddCard_containerCSS,
            onClick: handleOnClick,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    css: plusCSS(isCheming),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                        icon: ic_plus_bold
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                    children: [
                        "내 캐릭터를",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("br", {}),
                        "만들어 보세요 \uD83D\uDE0B"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var characters_CharacterAddCard = (CharacterAddCard);

// EXTERNAL MODULE: ./utils/number.ts
var number = __webpack_require__(85170);
;// CONCATENATED MODULE: ./components/characters/PlayCountCard.tsx
function PlayCountCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PlayCountCard_templateObject() {
    var data = PlayCountCard_taggedTemplateLiteral([
        "\n    ",
        ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: ",
        ";\n    color: ",
        ";\n    padding: 19px 0;\n    margin: ",
        ";\n    border-radius: ",
        "px;\n    font-weight: 400;\n\n    .count {\n      font-size: 14px;\n      line-height: 14px;\n      font-weight: 600;\n      margin-top: 10px;\n    }\n  "
    ]);
    PlayCountCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var PlayCountCard_containerCSS = function(isCheming) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(PlayCountCard_templateObject(), dist_esm/* Typography.body12 */.ZT.body12, isCheming ? theme.colors.main50 : theme.var.gray900, isCheming ? theme.var.black : theme.var.white, isCheming ? "0px 0px 20px" : "16px 0", dist_esm/* Radius.medium */.wU.medium);
    };
};
var PlayCountCard = function(param) {
    var isMyPage = param.isMyPage, user = param.user, player = param.player;
    var ref, ref1;
    var isCheming = (0,global/* useGlobalContext */.bN)().isCheming;
    var text = isCheming ? "이만큼 대화했어요 \uD83D\uDCAC" : "이만큼 플레이 했어요 \uD83D\uDC40";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: PlayCountCard_containerCSS(isCheming),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                children: [
                    isMyPage ? "유저들이 내 캐릭터를 " : "".concat(user === null || user === void 0 ? void 0 : user.nickname, "님의 캐릭터를 유저들이 "),
                    text
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                className: "count",
                children: (0,number/* formatKoreanCompactNumber */.n)((player === null || player === void 0 ? void 0 : (ref = player.stat) === null || ref === void 0 ? void 0 : ref.my_character_message_count) || 0) === "0" ? "-" : (0,number/* formatKoreanCompactNumber */.n)((player === null || player === void 0 ? void 0 : (ref1 = player.stat) === null || ref1 === void 0 ? void 0 : ref1.my_character_message_count) || 0)
            })
        ]
    });
};
/* harmony default export */ var characters_PlayCountCard = (PlayCountCard);

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(82740);
// EXTERNAL MODULE: ./components/common/ActionSheet.tsx
var ActionSheet = __webpack_require__(83898);
// EXTERNAL MODULE: ./components/common/EFinderImage.tsx + 1 modules
var EFinderImage = __webpack_require__(92145);
// EXTERNAL MODULE: ./components/layout/Pad.tsx
var Pad = __webpack_require__(95833);
;// CONCATENATED MODULE: ./public/icons/ic_lock_small.svg
var _g, _defs;
function ic_lock_small_extends() { ic_lock_small_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ic_lock_small_extends.apply(this, arguments); }

var SvgIcLockSmall = function SvgIcLockSmall(props) {
  return /*#__PURE__*/react.createElement("svg", ic_lock_small_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#ic_lock_small_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M9 4h-.5V3a2.5 2.5 0 0 0-5 0v1H3c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1M6 8.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1M4.5 4V3c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v1z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "ic_lock_small_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
/* harmony default export */ var ic_lock_small = (SvgIcLockSmall);
// EXTERNAL MODULE: ./public/icons/ic_play.svg
var ic_play = __webpack_require__(88797);
;// CONCATENATED MODULE: ./components/characters/ProfileInfoCard.tsx
function ProfileInfoCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProfileInfoCard_templateObject() {
    var data = ProfileInfoCard_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: ",
        "px;\n    border-radius: ",
        "px;\n    box-shadow: 3px -2px 20px 3px #0000000d;\n    overflow: hidden;\n\n    .imageContainer {\n      height: ",
        "px;\n      background-color: ",
        ";\n      position: relative;\n\n      .gradient {\n        position: absolute;\n        width: 100%;\n        height: 40px;\n        top: 0;\n        z-index: 1;\n        ",
        "\n      }\n\n      .icon-btn {\n        position: absolute;\n        top: 0px;\n        right: 0px;\n        z-index: 10;\n        padding: 0;\n        padding: 8px 10px;\n        margin: 0;\n      }\n\n      .playCount {\n        position: absolute;\n        width: 100%;\n        top: 0;\n        display: flex;\n        gap: ",
        "px;\n        padding: 10px;\n        ",
        ";\n        color: ",
        ";\n        z-index: 10;\n\n        svg path {\n          fill: currentcolor;\n        }\n      }\n\n      .image {\n        width: 100%;\n        height: ",
        "px;\n        background-color: ",
        ";\n      }\n    }\n\n    .info {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      padding: 10px 9px ",
        "px;\n\n      .name {\n        ",
        ";\n        ",
        "\n      }\n      .age {\n        ",
        ";\n        margin-top: ",
        "px;\n        margin-bottom: ",
        "px;\n        color: ",
        ";\n        ",
        "\n      }\n      .desc {\n        ",
        ";\n        font-weight: 600;\n        ",
        "\n      }\n    }\n  "
    ]);
    ProfileInfoCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var cardContainerCSS = function(size) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(ProfileInfoCard_templateObject(), size.height, dist_esm/* Radius.small */.wU.small, size.imageHeight, theme.var.white, (0,css/* linearGradient */.bC)("top", "rgba(255, 255, 255, 0)", "rgba(0, 0, 0, 0.2)"), dist_esm/* Spacing.xxxsmall */.Ki.xxxsmall, dist_esm/* Typography.body11 */.ZT.body11, theme.var.white, size.imageHeight, theme.var.gray200, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Typography.body12 */.ZT.body12, (0,css/* multilineEllipsis */.Zy)(1), size.infoFontSize === 11 ? dist_esm/* Typography.body11 */.ZT.body11 : dist_esm/* Typography.body12 */.ZT.body12, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Spacing.xsmall */.Ki.xsmall, theme.var.gray500, (0,css/* multilineEllipsis */.Zy)(1), dist_esm/* Typography.body12 */.ZT.body12, (0,css/* multilineEllipsis */.Zy)(1));
    };
};
var ProfileInfoCardSize = {
    w166: {
        width: 166,
        height: 216,
        imageHeight: 140,
        infoFontSize: 12
    },
    w128: {
        width: 128,
        height: 199,
        imageHeight: 126,
        infoFontSize: 11
    }
};
var ProfileInfoCard = function(param) {
    var data = param.data, _size = param.size, size = _size === void 0 ? "w128" : _size, isMyPage = param.isMyPage, handleActionSheet = param.handleActionSheet, handleSelectCharacter = param.handleSelectCharacter, handleCreateChat = param.handleCreateChat, handleNavigateEdit = param.handleNavigateEdit;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var information = data.information;
    var t = (0,esm/* useTranslation */.$G)().t;
    var isTemp = data.status === "DRF";
    var isPrivate = data.status === "PRV";
    var getActionSheetValue = (0,react.useCallback)(function() {
        if (isMyPage) {
            if (isTemp) {
                return [
                    {
                        label: t("수정하기"),
                        value: "modify"
                    },
                    {
                        label: t("삭제하기"),
                        value: "delete",
                        isDanger: true
                    }, 
                ];
            } else {
                return [
                    {
                        label: t("캐릭터 상세로 가기"),
                        value: "detail"
                    },
                    {
                        label: t("수정하기"),
                        value: "modify"
                    },
                    {
                        label: t("삭제하기"),
                        value: "delete",
                        isDanger: true
                    }, 
                ];
            }
        } else {
            return [
                {
                    label: t("캐릭터 상세로 가기"),
                    value: "detail"
                },
                {
                    label: t("신고하기"),
                    value: "report",
                    isDanger: true
                }, 
            ];
        }
        return [];
    }, [
        isMyPage,
        isTemp,
        t
    ]);
    var ref = (0,react.useState)(getActionSheetValue()), actions = ref[0];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: cardContainerCSS(ProfileInfoCardSize[size]),
        onClick: function() {
            return isTemp ? handleNavigateEdit(data) : handleCreateChat(data.id);
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "imageContainer",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
                        className: "gradient"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: "playCount",
                                children: isTemp ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                    children: "임시저장"
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                            icon: isPrivate ? ic_lock_small : ic_play/* default */.Z
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                            children: (0,number/* formatKoreanCompactNumber */.n)(data.stat.message_count)
                                        })
                                    ]
                                })
                            }),
                            handleActionSheet && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ActionSheet/* default */.Z, {
                                name: "character-card-action-".concat(data.id),
                                options: actions,
                                onSelect: function(value) {
                                    return handleActionSheet(value);
                                },
                                children: function(open) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                        className: "icon-btn",
                                        onClick: function(e) {
                                            open(e);
                                            handleSelectCharacter(data);
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                            icon: icon/* VerticalEllipsis */.oR,
                                            color: theme.var.white,
                                            size: dist_esm/* Sizes.small */.u8.small
                                        })
                                    });
                                }
                            })
                        ]
                    }),
                    (data === null || data === void 0 ? void 0 : data.profile_image) && (data === null || data === void 0 ? void 0 : data.profile_image.key) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                        image: data.profile_image,
                        alt: "profile_img"
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: "image"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "info",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                        className: "name",
                        children: information.name || "캐릭터 이름"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "age",
                        children: "".concat(information.age || "N", "세 | ").concat(information.job || "직업")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "desc",
                        children: data.greeting || "캐릭터 한마디"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var characters_ProfileInfoCard = (ProfileInfoCard);

;// CONCATENATED MODULE: ./components/characters/CharacterCardList.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function CharacterCardList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function CharacterCardList_templateObject() {
    var data = CharacterCardList_taggedTemplateLiteral([
        "\n  padding: 0 ",
        "px;\n  ",
        " {\n    padding: 0 ",
        "px;\n  }\n  ",
        " {\n    padding: 0 ",
        "px;\n  }\n\n  .cheming-stat-container {\n    margin-top: 9px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    ",
        ";\n    gap: 3px;\n    margin-bottom: 21px;\n    .comment-count {\n      ",
        ";\n      color: #90949b;\n    }\n  }\n"
    ]);
    CharacterCardList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CharacterCardList_templateObject1() {
    var data = CharacterCardList_taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    margin-top: ",
        "px;\n    margin-bottom: 10px;\n\n    .dropdown {\n      > div {\n        ",
        ";\n        border: 1px solid ",
        ";\n        border-radius: ",
        "px;\n        height: 35px;\n        padding: ",
        "px;\n        background-color: ",
        ";\n      }\n      > ul {\n        z-index: 20;\n      }\n    }\n    .count {\n      ",
        ";\n    }\n  "
    ]);
    CharacterCardList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = CharacterCardList_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  column-gap: ",
        "px;\n  row-gap: ",
        "px;\n  ",
        " {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  ",
        " {\n    grid-template-columns: repeat(4, 1fr);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


























var CharacterCardList_containerCSS = function() {
    return (0,emotion_react_browser_esm.css)(CharacterCardList_templateObject(), dist_esm/* Spacing.medium */.Ki.medium, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Typography.body14 */.ZT.body14, dist_esm/* Typography.body12 */.ZT.body12);
};
var filterHeaderCSS = function(isCheming) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(CharacterCardList_templateObject1(), dist_esm/* Spacing.xxsmall */.Ki.xxsmall, isCheming ? "color:#7F00FF" : "", theme.var.gray300, dist_esm/* Radius.medium */.wU.medium, dist_esm/* Spacing.xsmall */.Ki.xsmall, theme.var.white, dist_esm/* Typography.body12 */.ZT.body12);
    };
};
var iteratorCSS = (0,emotion_react_browser_esm.css)(_templateObject2(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small, css/* media.tablet */.BC.tablet, css/* media.desktop */.BC.desktop);
var CharacterCardList = function(param) {
    var userId = param.userId, isMyPage = param.isMyPage;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,global/* useGlobalContext */.bN)(), platform = ref.platform, isCheming = ref.isCheming;
    var web = (0,webview/* useWebView */.B9)().web;
    var router = (0,next_router.useRouter)();
    var queryClient = (0,es.useQueryClient)();
    var options = [
        {
            label: "최신순",
            value: "id"
        },
        {
            label: "인기순",
            value: "stat__message_count"
        }, 
    ];
    var ref1 = (0,react.useState)(options[0]), orderValue = ref1[0], setOrderValue = ref1[1];
    var ref2 = (0,react.useState)(null), selectedCharacter = ref2[0], setSelectedCharacter = ref2[1];
    var ref3 = (0,react.useState)(false), isDeleteAction = ref3[0], setIsDeleteAction = ref3[1];
    var useFetchUser = (0,useUserQuery/* useUserQuery */.b)().useFetchUser;
    var ref4 = useFetchUser(userId), user = ref4.data;
    var ref5 = (0,usePlayer/* usePlayer */.n)(userId, {
        refetchOnWindowFocus: isCheming ? false : "always"
    }), player = ref5.data;
    var myCharacterQueryKey = constants/* QUERY_KEYS.CHARACTER.MY_CHARACTER_LIST */.U7.CHARACTER.MY_CHARACTER_LIST(orderValue.value);
    var myCharacterQuery = (0,query/* useChatPaginationQuery */.aI)(myCharacterQueryKey, function(param) {
        var pageParam = param.pageParam;
        return (0,chatbot/* fetchMyCharacters */.p6)({
            orderBy: orderValue.value
        }, pageParam);
    }, {
        enabled: isMyPage
    });
    var userCharacterQuery = (0,query/* useChatPaginationQuery */.aI)(constants/* QUERY_KEYS.CHARACTER.USERS */.U7.CHARACTER.USERS(userId, orderValue.value), function(param) {
        var pageParam = param.pageParam;
        return (0,chatbot/* fetchCharacters */.Em)({
            user_id: userId,
            order_by: orderValue.value,
            status: "PUB"
        }, pageParam);
    }, {
        enabled: !isMyPage
    });
    var ref6 = (0,es.useMutation)(function(characterId) {
        return (0,chatbot/* deletePlaySet */.o6)(characterId);
    }, {
        onSettled: function() {
            closeCharacterDeleteModal();
            alert("캐릭터 삭제가 완료되었습니다.");
            postChannelMessage("delete");
            constants/* QUERY_KEYS.CHAT_ROOM.LIST */.U7.CHAT_ROOM.LIST("Library");
            queryClient.invalidateQueries(constants/* QUERY_KEYS.CHAT_ROOM.LIST */.U7.CHAT_ROOM.LIST("Library"));
            queryClient.invalidateQueries(constants/* QUERY_KEYS.CHARACTER.MY_CHARACTER_LIST */.U7.CHARACTER.MY_CHARACTER_LIST(orderValue.value));
            setSelectedCharacter(null);
        }
    }), deleteCharacter = ref6.mutate;
    var ref7 = _slicedToArray((0,useModal/* useModal */.d)("character-delete"), 2), isCharacterDeleteModalOpen = ref7[0], ref8 = ref7[1], openCharacterDeleteModal = ref8.open, closeCharacterDeleteModal = ref8.close;
    (0,useScrollPosition/* useScrollPosition */.R)("userCharacterCardList:".concat(userId));
    (0,useBroadcastChannel/* useBroadcastChannel */.t)(useBroadcastChannel/* BROADCAST_CHANNEL.CHARACTER_UPDATE */._.CHARACTER_UPDATE, function() {
        queryClient.invalidateQueries(myCharacterQueryKey);
    });
    (0,useBroadcastChannel/* useBroadcastChannel */.t)(useBroadcastChannel/* BROADCAST_CHANNEL.CHARACTER_DELETE */._.CHARACTER_DELETE, function() {
        queryClient.invalidateQueries(myCharacterQueryKey);
    });
    var postChannelMessage = (0,useBroadcastChannel/* useBroadcastChannel */.t)(useBroadcastChannel/* BROADCAST_CHANNEL.CHARACTER_DELETE */._.CHARACTER_DELETE).postChannelMessage;
    var handleSelectCharacter = function(character) {
        setSelectedCharacter(character);
    };
    var handleCreateChat = function() {
        var _ref = _asyncToGenerator(function(characterId) {
            var data;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,chatbot/* fetchSituations */.XZ)({
                                character_id: characterId
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        if (data && data.items[0].id) {
                            if (platform === constants/* Platform.web */.t4.web) {
                                router.push("/play/situations/".concat(data.items[0].id, "/chat-room"));
                            } else {
                                web.openPage("/play/situations/".concat(data.items[0].id, "/chat-room"));
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCreateChat(characterId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNavigateCreate = function() {
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/create");
        }
        web.openPage("/play/characters/create");
    };
    var handleNavigateEdit = function(character) {
        var type = (character === null || character === void 0 ? void 0 : character.can_have_visual) ? "visual" : "default";
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/".concat(character.id, "/edit?characterType=").concat(type));
        }
        web.openPage("/play/characters/".concat(character.id, "/edit?characterType=").concat(type));
    };
    var handleNavigateChemingEdit = function(character) {
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/".concat(character.id, "/edit"));
        }
        web.openPage("/play/characters/".concat(character.id, "/edit"));
    };
    var handleConfirmDeleteCharacter = function(characterId) {
        deleteCharacter(characterId);
        setSelectedCharacter(null);
    };
    var handleActionSheet = function(value) {
        if (selectedCharacter) {
            var type = (selectedCharacter === null || selectedCharacter === void 0 ? void 0 : selectedCharacter.can_have_visual) ? "visual" : "default";
            switch(value){
                case "modify":
                    setIsDeleteAction(false);
                    if (platform === constants/* Platform.web */.t4.web) {
                        router.push("/play/characters/".concat(selectedCharacter.id, "/edit?characterType=").concat(type));
                    }
                    web.openPage("/play/characters/".concat(selectedCharacter.id, "/edit?characterType=").concat(type));
                    break;
                case "delete":
                    if (selectedCharacter.status === "DRF") {
                        if (confirm("정말 삭제하시겠습니까?")) {
                            handleConfirmDeleteCharacter(selectedCharacter.id);
                        }
                    } else {
                        setIsDeleteAction(true);
                        openCharacterDeleteModal();
                    }
                    break;
                case "detail":
                    setIsDeleteAction(false);
                    if (platform === constants/* Platform.web */.t4.web) {
                        router.push("/play/characters/".concat(selectedCharacter.id));
                    }
                    web.openPage("/play/characters/".concat(selectedCharacter.id));
                    break;
                case "report":
                    if (platform === constants/* Platform.web */.t4.web) {
                        router.push("/report".concat((0,misc/* toQueryString */.UK)({
                            objectType: constants/* ReportObjectType.character */.LB.character,
                            object_id: selectedCharacter.id
                        })));
                    }
                    web.openPage("/report".concat((0,misc/* toQueryString */.UK)({
                        objectType: constants/* ReportObjectType.character */.LB.character,
                        object_id: selectedCharacter.id
                    })));
                    break;
                default:
                    break;
            }
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: CharacterCardList_containerCSS,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_PlayCountCard, {
                isMyPage: isMyPage,
                user: user,
                player: player
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: filterHeaderCSS(isCheming),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_form/* Select */.Ph, {
                        className: "dropdown",
                        name: "order",
                        fontSize: dist_esm/* FontSizes.small */.TS.small,
                        options: options,
                        selected: orderValue,
                        onChange: function(values) {
                            return setOrderValue(values);
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "count",
                        children: t("{{count}}개의 캐릭터", {
                            count: isMyPage ? (0,misc/* formatComma */.cO)(myCharacterQuery === null || myCharacterQuery === void 0 ? void 0 : myCharacterQuery.totalCount) : (0,misc/* formatComma */.cO)(userCharacterQuery === null || userCharacterQuery === void 0 ? void 0 : userCharacterQuery.totalCount)
                        })
                    })
                ]
            }),
            isMyPage ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                name: "my-character-card-list",
                query: myCharacterQuery,
                css: iteratorCSS,
                ad: isMyPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_CharacterAddCard, {
                    handleOnClick: handleNavigateCreate,
                    isCheming: isCheming
                }),
                children: function(item) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_ProfileInfoCard, {
                        data: item,
                        handleActionSheet: handleActionSheet,
                        handleSelectCharacter: handleSelectCharacter,
                        isMyPage: isMyPage,
                        size: "w166",
                        handleCreateChat: handleCreateChat,
                        handleNavigateEdit: isCheming ? handleNavigateChemingEdit : handleNavigateEdit
                    });
                }
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                name: "user-character-card-list",
                query: userCharacterQuery,
                css: iteratorCSS,
                children: function(item) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_ProfileInfoCard, {
                        data: item,
                        handleActionSheet: handleActionSheet,
                        handleSelectCharacter: handleSelectCharacter,
                        isMyPage: false,
                        size: "w166",
                        handleCreateChat: handleCreateChat,
                        handleNavigateEdit: isCheming ? handleNavigateChemingEdit : handleNavigateEdit
                    });
                }
            }),
            !isMyPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Empty/* default */.Z, {
                query: userCharacterQuery,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    children: t("아직 캐릭터가 없습니다.")
                })
            }),
            isDeleteAction && selectedCharacter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CharacterDeleteModal/* default */.Z, {
                open: isCharacterDeleteModalOpen,
                onClose: closeCharacterDeleteModal,
                handleOnConfirm: handleConfirmDeleteCharacter,
                character: selectedCharacter
            })
        ]
    });
};
/* harmony default export */ var characters_CharacterCardList = (CharacterCardList);


/***/ }),

/***/ 60280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11717);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61527);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82740);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81946);
/* harmony import */ var _common_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59585);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: scroll;\n\n  .title {\n    ",
        ";\n    text-align: center;\n    line-height: 16px;\n    font-weight: 700;\n    margin-bottom: ",
        "px;\n    padding-top: ",
        "px;\n  }\n  .close {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n  }\n\n  p {\n    ",
        ";\n  }\n\n  ul {\n    display: flex;\n    flex-direction: column;\n    padding: 0 ",
        "px;\n    margin: ",
        "px 0;\n    gap: ",
        "px;\n  }\n\n  ul > li {\n    word-break: break-all;\n    ",
        ";\n    list-style-type: disc;\n    color: ",
        ";\n    line-height: 18.9px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var containerCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.h4 */ .ZT.h4, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xlarge */ .Ki.xlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xhsmall */ .Ki.xhsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.h5 */ .ZT.h5, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xlarge */ .Ki.xlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body14 */ .ZT.body14, theme.colors.red500);
};
var CharacterDeleteModal = function(_param) {
    var handleOnConfirm = _param.handleOnConfirm, character = _param.character, props = _objectWithoutProperties(_param, [
        "handleOnConfirm",
        "character"
    ]);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_5__/* .useWebView */ .B9)().web;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), value = ref[0], setValue = ref[1];
    var handleChangeInput = function(e) {
        setValue(e.currentTarget.value);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        web.setIsBottomInputPage(true);
        return function() {
            web.setIsBottomInputPage(false);
        };
    }, [
        web
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_common_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({}, props), {
        blocking: false,
        onClose: props.onClose,
        header: false,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            css: containerCSS,
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                    className: "close",
                    onClick: function() {
                        return props.onClose();
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                        icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_4__/* .Close */ .x8
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                    className: "title",
                    children: t("캐릭터 삭제")
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
                    children: t("정말 {{characterName}} 캐릭터를 삭제하시겠습니까?", {
                        characterName: character.name
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("li", {
                            children: t("캐릭터 삭제 시 해당 캐릭터와 대화했던 모든 대화방이 삭제됩니다.")
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("li", {
                            children: t("캐릭터 삭제를 원하신다면 캐릭터명을 아래 입력하신 후 삭제하기 버튼을 눌러주세요.")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chatie_design_system_form__WEBPACK_IMPORTED_MODULE_3__/* .Input */ .II, {
                    placeholder: "캐릭터명을 입력해주세요",
                    value: value,
                    onChange: handleChangeInput
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_common_Modal__WEBPACK_IMPORTED_MODULE_6__/* .ModalButton */ .mH, {
                    text: t("삭제하기"),
                    onClick: function() {
                        return handleOnConfirm(character.id);
                    },
                    disabled: value !== character.name
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CharacterDeleteModal);


/***/ }),

/***/ 75046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ usePlayerStats; },
/* harmony export */   "n": function() { return /* binding */ usePlayer; }
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54909);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72218);
/* harmony import */ var _api_chatbot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23082);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45432);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var usePlayer = function(id, options) {
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.PLAYER */ .U7.PLAYER(id), function() {
        return (0,_api_chatbot__WEBPACK_IMPORTED_MODULE_1__/* .fetchPlayer */ .I_)(id);
    }, _objectSpread({
        enabled: !!id,
        staleTime: (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(60),
        cacheTime: (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(60)
    }, options));
    return query;
};
var usePlayerStats = function(options) {
    var query = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(_constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.MY_STATS */ .U7.MY_STATS, function() {
        return (0,_api_chatbot__WEBPACK_IMPORTED_MODULE_1__/* .fetchMyPlayerStats */ .zJ)();
    }, _objectSpread({
        staleTime: (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(60),
        cacheTime: (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(60)
    }, options));
    return query;
};


/***/ }),

/***/ 41785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ BROADCAST_CHANNEL; },
/* harmony export */   "t": function() { return /* binding */ useBroadcastChannel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var broadcast_channel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38718);
/* harmony import */ var semver__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64912);
/* harmony import */ var semver__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(semver__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45432);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30259);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45874);






var BROADCAST_CHANNEL = {
    CHARACTER_UPDATE: "character_update",
    CHARACTER_DELETE: "character_delete",
    VERIFICATION_EVENT_CONFIRM: "verification_event_confirm",
    PURCHASE_DAILY_FREE_PASS: "purchase_daily_free_pass"
};
function useBroadcastChannel(channelName, onMessage, options) {
    var ref = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_3__/* .useGlobalContext */ .bN)(), platform = ref.platform, os = ref.os;
    var isUnderVersion = platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && os && !semver__WEBPACK_IMPORTED_MODULE_1___default().gte((0,_utils_misc__WEBPACK_IMPORTED_MODULE_4__/* .normalizeVersion */ .Kt)(os), "15.4.0");
    var broadcastChannelRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var onMessageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var handlePostMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(message) {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && isUnderVersion) {
            return;
        }
        if (broadcastChannelRef.current) {
            broadcastChannelRef.current.postMessage(message);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && isUnderVersion) {
            return;
        }
        if (onMessage) {
            onMessageRef.current = onMessage;
        }
    }, [
        onMessage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && isUnderVersion) {
            return;
        }
        var mounted = true;
        var channel = new broadcast_channel__WEBPACK_IMPORTED_MODULE_5__/* .BroadcastChannel */ .g0(channelName, options);
        var handleMessage = function(message) {
            var ref;
            if (!mounted) {
                return;
            }
            (ref = onMessageRef.current) === null || ref === void 0 ? void 0 : ref.call(onMessageRef, message);
        };
        channel.onmessage = handleMessage;
        broadcastChannelRef.current = channel;
        return function() {
            mounted = false;
            broadcastChannelRef.current = null;
            channel.close();
        };
    }, [
        channelName,
        options
    ]);
    return {
        postChannelMessage: handlePostMessage
    };
}


/***/ }),

/***/ 88797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIcPlay = function SvgIcPlay(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#BBB",
    d: "M9.917 5.265 2.899.972a.78.78 0 0 0-1.185.658v8.585a.776.776 0 0 0 1.187.659L9.917 6.58a.77.77 0 0 0 0-1.315v-.001m-7.423 4.941v-8.57l7.005 4.287-7.005 4.283"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgIcPlay);

/***/ })

}]);